import { useSelector } from "react-redux";
import "moment/locale/az";
import "./style.css";
import moment from "moment-timezone";
import { useCustomHook } from "../../GlobalFunctions/globalFunctions";

import { useEffect } from "react";

const UpdatesModalGroupDetails = () => {
  const { updatesModalData: modalData } = useSelector(
    (state) => state.updatesModal,
  );

  const isLessonDateChanged =
    JSON.stringify(modalData?.oldData?.lessonDate) !==
    JSON.stringify(modalData?.newData?.lessonDate);

  const oldTeachers =
    Array.isArray(modalData?.oldData?.teachers) &&
    modalData?.oldData?.teachers.length > 0
      ? modalData?.oldData.teachers
          .map((teacher) => {
            return `${teacher?.fullName}`;
          })
          .join(", ")
      : "";

  const newTeachers =
    Array.isArray(modalData?.newData?.teachers) &&
    modalData?.newData?.teachers.length > 0
      ? modalData?.newData.teachers
          .map((teacher) => {
            return `${teacher?.fullName}`;
          })
          .join(", ")
      : "";

  const oldMentors =
    Array.isArray(modalData?.oldData?.mentors) &&
    modalData?.oldData?.mentors.length > 0
      ? modalData?.oldData.mentors
          .map((mentor) => {
            return `${mentor?.fullName}`;
          })
          .join(", ")
      : "";

  const newMentors =
    Array.isArray(modalData?.newData?.mentors) &&
    modalData?.newData?.mentors.length > 0
      ? modalData?.newData.mentors
          .map((mentor) => {
            return `${mentor?.fullName}`;
          })
          .join(", ")
      : "";

  const oldStudents =
    Array.isArray(modalData?.oldData?.students) &&
    modalData?.oldData?.students.length > 0
      ? modalData?.oldData.students
          .map((student) => {
            return `${student?.fullName}`;
          })
          .join(", ")
      : "";

  const newStudents =
    Array.isArray(modalData?.newData?.students) &&
    modalData?.newData?.students.length > 0
      ? modalData?.newData.students
          .map((student) => {
            return `${student?.fullName}`;
          })
          .join(", ")
      : "";

  const renderUpdateRow = (label, oldVal, newVal) => {
    const hasChanged = oldVal !== newVal;
    const arrowColor = hasChanged ? "#e74c3c" : "#2ecc71";

    return (
      <div className="update-row">
        <span className="updates-key">{label}:</span>
        <span className="update-value old">{oldVal}</span>
        {modalData.action === "update" && (
          <>
            <span className="update-arrow" style={{ color: arrowColor }}>
              &#8594;
            </span>
            <span className={`update-value new ${hasChanged ? "change" : ""} `}>
              {newVal}
            </span>
          </>
        )}
      </div>
    );
  };

  return (
    <>
      <div className="updates-datas-container">
        <div className="updates-list">
          {renderUpdateRow(
            "Ad",
            modalData?.oldData?.name,
            modalData?.newData?.name,
          )}
          {renderUpdateRow(
            "Başlama tarixi",
            moment(modalData?.oldData?.startDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY"),
            moment(modalData?.newData?.startDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY"),
          )}
          {renderUpdateRow(
            "Bitmə tarixi",
            moment(modalData?.oldData?.endDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY"),
            moment(modalData?.newData?.endDate)
              .tz("Asia/Baku")
              .format("DD:MM:YYYY"),
          )}
          {renderUpdateRow(
            "Status",
            modalData?.oldData?.status === "waiting"
              ? "Yığılan"
              : modalData?.oldData?.status === "current"
                ? "Mövcud"
                : "Bitmiş",
            modalData?.newData?.status === "waiting"
              ? "Yığılan"
              : modalData?.newData?.status === "current"
                ? "Mövcud"
                : "Bitmiş",
          )}
          {renderUpdateRow(
            "Kurs",
            modalData?.oldData?.course?.name,
            modalData?.newData?.course?.name,
          )}
          {renderUpdateRow(
            "Otaq",
            modalData?.oldData?.room?.name,
            modalData?.newData?.room?.name,
          )}
          {renderUpdateRow(
            "Lab otaq",
            modalData?.oldData?.labRoom?.name,
            modalData?.newData?.labRoom?.name,
          )}
          {renderUpdateRow("Məllimlər", oldTeachers, newTeachers)}
          {renderUpdateRow("Mentorlar", oldMentors, newMentors)}
          {renderUpdateRow("Tələbələr", oldStudents, newStudents)}
          <div className="update-row">
            <span className="updates-key">Dərs vaxtları:</span>
            <span className="update-value old">
              {modalData?.oldData?.lessonDate?.map((item) => {
                return (
                  <div>
                    <span>{item.day}-ci gün</span> <span>{item.startTime}</span>
                    -<span>{item.endTime}</span>
                  </div>
                );
              })}
            </span>
            {modalData.action === "update" && (
              <>
                <span
                  className="update-arrow"
                  style={{ color: isLessonDateChanged ? "#e74c3c" : "#2ecc71" }}
                >
                  &#8594;
                </span>
                <span
                  className={`update-value new ${
                    isLessonDateChanged ? "change" : ""
                  } `}
                >
                  {modalData?.newData?.lessonDate?.map((item) => {
                    return (
                      <div>
                        <span>{item.day}-ci gün</span>{" "}
                        <span>{item.startTime}</span>-
                        <span>{item.endTime}</span>
                      </div>
                    );
                  })}
                </span>
              </>
            )}
          </div>
        </div>
      </div>
      {/* <div className="status-button-container">
        <button
          onClick={() => setActiveStatus("pending")}
          className={activeStatus === "pending" ? "active" : ""}
        >
          Gözləmədə
        </button>
        <button
          disabled={!confirmedBtn}
          onClick={() => setActiveStatus("confirmed")}
          className={activeStatus === "confirmed" ? "active" : ""}
          style={!confirmedBtn ? { cursor: "not-allowed" } : {}}
        >
          Təsdiqləndi
        </button>
        <button
          onClick={() => setActiveStatus("cancelled")}
          className={activeStatus === "cancelled" ? "active" : ""}
        >
          Ləğv edildi
        </button>
      </div> */}
      {/* {modalData.status === "pending" && updateBtn && (
        <div className="create-update-modal-btn">
          <button disabled={updatesModalLoading} onClick={changeUpdatesStatus}>
            {updatesModalLoading ? <LoadingBtn /> : "Yenilə"}
          </button>
        </div>
      )} */}
    </>
  );
};

export default UpdatesModalGroupDetails;
